import styled from '@emotion/styled';
import { getBorders, spacing, getTextType, getTextColor } from '../../style';
import breakpoints from '../../theme/material/breakpoints';
import { IHeaderProps, ITitleProps } from './types';

const Header = styled('div')<IHeaderProps>(
  {
    alignItems: 'baseline',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 0',
  },
  ({ panelHeader }) =>
    panelHeader && {
      padding: 16,
      marginBottom: 0,
    },
  ({ bottomRuled }) =>
    bottomRuled && {
      borderBottom: getBorders().DEFAULT,
      marginBottom: 18,
    }
);

const Text = styled('div')(() => ({
  ...getTextColor().NORMAL,
  lineHeight: '20px',
  wordBreak: 'break-word',
  ...spacing.MARGIN_BOTTOM_SM,
  ...getTextType().text,
}));

const Title = styled('h2')<ITitleProps>(
  () => ({
    ...getTextType().header,
    [breakpoints.down(378.05)]: {
      fontSize: 19,
    },
    [breakpoints.down(350.05)]: {
      fontSize: 16,
    },
  }),
  ({ marginBtm }) => ({
    marginBottom: marginBtm ? 12 : 0,
  })
);

const SectionHeader = styled('h1')(() => ({
  ...getTextType().header,
}));

export { Header, Text, Title, SectionHeader };
